/**
 * Customer-facing plan labels. Internal API / enum values stay 'Free' | 'Starter' | 'Growth' | 'Pro'.
 * Prefer this helper for any string a customer sees; keep comparisons on the enum key.
 */

export const PLAN_DISPLAY = Object.freeze({
  Free: { name: 'OMS Lite', short: 'Lite' },
  Starter: { name: 'Starter', short: 'Starter' },
  Growth: { name: 'Growth', short: 'Growth' },
  Pro: { name: 'Pro', short: 'Pro' },
})

const DEFAULT_PLAN_KEY = 'Free'

const PLAN_ALIASES = Object.freeze({
  free: 'Free',
  lite: 'Free',
  'oms lite': 'Free',
  'free plan': 'Free',
  starter: 'Starter',
  growth: 'Growth',
  pro: 'Pro',
})

/**
 * Normalise a loose plan string to an internal plan key.
 * @param {string|null|undefined} plan
 * @returns {'Free'|'Starter'|'Growth'|'Pro'}
 */
export function normalizePlanKey(plan) {
  const lower = String(plan || '')
    .trim()
    .toLowerCase()
  return PLAN_ALIASES[lower] || DEFAULT_PLAN_KEY
}

/**
 * @param {string|null|undefined} plan - Internal plan key (e.g. 'Free') or loose casing
 * @param {{ short?: boolean }} [opts]
 * @returns {string}
 */
export function planDisplayName(plan, { short = false } = {}) {
  const entry = PLAN_DISPLAY[normalizePlanKey(plan)]
  return short ? entry.short : entry.name
}

/** Ordered list for comparison copy: "Lite, Starter, Growth, and Pro" */
export const PLAN_COMPARISON_LIST = 'Lite, Starter, Growth, and Pro'
